import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-milestones-progress-overlay-footer',
  templateUrl: './milestones-progress-overlay-footer.component.html',
  styleUrls: ['./milestones-progress-overlay-footer.component.scss']
})
export class MilestonesProgressOverlayFooterComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
}
